const renames = {
  // Map some Salesforce field names to the reserved identify trait names
  // listed in https://docs.customer.io/cdp/sources/source-spec/identify-spec/#traits
  //
  // Related Salesforce object types:
  // - https://developer.salesforce.com/docs/atlas.en-us.object_reference.meta/object_reference/sforce_api_objects_lead.htm
  // - https://developer.salesforce.com/docs/atlas.en-us.object_reference.meta/object_reference/sforce_api_objects_contact.htm
  identify: {
    Description: 'description',
    Email: 'email',
    FirstName: 'firstName',
    LastName: 'lastName',
    Name: 'name',
    Phone: 'phone',
    Title: 'title',
    Website: 'website',
  },

  // Map some Salesforce field names to the reserved group trait names
  // listed in https://docs.customer.io/cdp/sources/source-spec/group-spec/#traits
  //
  // Related Salesforce object types:
  // - https://developer.salesforce.com/docs/atlas.en-us.object_reference.meta/object_reference/sforce_api_objects_opportunity.htm
  group: {
    Description: 'description',
    Name: 'name',
    Phone: 'phone',
    Website: 'website',
  },

  // Default renames for `relationship` syncs.
  relationship: {
    Description: 'description',
    Name: 'name',
  },
};

export default renames;
